import { BalanceType } from "@src/app/balanceStore"
import { Currency } from "@src/app/CurrenciesCollection/types"

const defaultDecimals = 2

export function mergeArrays(balance: BalanceType[], currencies: Currency[]) {
  return balance.map((item) => {
    const currency = currencies.find(
      (i) => i.network === item.network && i.symbol === item.symbol,
    )

    return {
      ...item,
      decimals: currency?.decimals,
      display_name: currency?.display_name,
      id:
        currency?.id ||
        `${item?.symbol}_${item?.network}_${null}_${defaultDecimals}`, // fiat id,
      symbol_alias: currency?.symbol_alias,
      token_kind: currency?.token_kind,
    }
  })
}
